import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class PersonTitleService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/PersonTitles`);
    }
}